/**
 * @author PoornaChandu
 * @description 
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import GraphComponent from './Widget/GraphComponent';
import AllGraphComponent from './Widget/AllGraphComponent';
const DataComponent = (props) => {
  const [filterData, setFilterData] = useState(props.filterData || []);
  const [allFilterData, setAllFilterData] = useState(props.allFilterData || []);
  const [operatorList, setOperatorList] = useState(props.OperatorList || []);
  const [codeType,setCodeType] = useState(props && props.CodeType ? props.CodeType : 'Device');
  // const [observationList, setObservationList] = useState([]);
  useEffect(() => {
    setFilterData(props.FilterData);
    setAllFilterData(props.AllFilterData);
    setOperatorList(props.OperatorList);
    setCodeType(props.CodeType);
  }, [props.FilterData, props.AllFilterData, props.OperatorList,props.CodeType]);
  const handleObservationList = (observationList) => {
    props.ObservationList(observationList);
  };
  return (
    <div>
      <GraphComponent 
        FilterData={filterData} 
        OperatorList={operatorList}
        CodeType={codeType} 
      />
      <div style={{ marginTop: '100px' }}>
        <AllGraphComponent
          AllFilterData={allFilterData}
          OperatorList={operatorList}
          ObservationList={handleObservationList}
          CodeType={codeType}
          FilterData={filterData}
        />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});
export default connect(mapStateToProps)(DataComponent);